/**
 * Favoritos de atajos de Revit por usuario.
 *
 * Espejo de lib/favorites.ts (biblioteca) pero apuntando a la tabla
 * `shortcut_favorites` (creada en 20260616030000_create_shortcut_favorites.sql).
 *
 * RLS garantiza que cada usuario solo ve/escribe sus propios favoritos.
 */
import { supabase } from './supabase';

/** Set de códigos de atajo (ej: "WA", "DR") que el usuario actual marcó. */
export async function listMyShortcutFavorites(): Promise<Set<string>> {
  const { data, error } = await supabase
    .from('shortcut_favorites')
    .select('shortcut_code');
  if (error) {
    console.error('[shortcut-favorites] list:', error);
    return new Set();
  }
  return new Set((data ?? []).map((r: any) => String(r.shortcut_code).toUpperCase()));
}

/**
 * Toggle: si el atajo está marcado lo borra, si no, lo agrega.
 * Optimista — el caller asume éxito; si retorna null hay que revertir.
 */
export async function toggleShortcutFavorite(
  code: string,
  currentlyFavorite: boolean,
): Promise<boolean | null> {
  const normalized = code.toUpperCase();

  if (currentlyFavorite) {
    const { error } = await supabase
      .from('shortcut_favorites')
      .delete()
      .eq('shortcut_code', normalized);
    if (error) {
      console.error('[shortcut-favorites] delete:', error);
      return null;
    }
    return false;
  }

  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return null;

  const { error } = await supabase
    .from('shortcut_favorites')
    .insert({ user_id: user.id, shortcut_code: normalized });
  if (error) {
    console.error('[shortcut-favorites] insert:', error);
    return null;
  }
  return true;
}
